export enum AutomaticEnum {
  Enabled = 'Enabled',
  Disabled = 'Disabled',
}

export enum ProcessKey {
  UpdateStart = 'updateStart',
  DownloadStart = 'downloadStart',
  Downloading = 'downloading',
  Updating = 'updating',
}

export enum UpdateProcess {
  Download = 'download',
  Update = 'update',
}
